module.exports = __webpack_public_path__ + "img/13.fe3fa2e1.png";